<template>
  <base-container>
    <el-form
      ref="bannerForm"
      :model="formData"
      :rules="rules"
      size="medium"
      label-width="100px"
    >
      <el-form-item label="轮播图" prop="url" required>
        <single-upload-cos v-model="formData.url" />
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="formData.title"
          :maxlength="50"
          placeholder="请输入名称"
          show-word-limit
          clearable
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="备注" prop="comment">
        <el-input
          v-model="formData.comment"
          show-word-limit
          :maxlength="50"
          placeholder="请输入备注"
          clearable
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="外链" prop="comment">
        <el-input
          v-model="formData.link"
          show-word-limit
          :maxlength="100"
          placeholder="请输入外链"
          clearable
          :style="{ width: '100%' }"
        />
      </el-form-item>
      <el-form-item label="展现位置" prop="position">
        <el-select
          v-model="formData.position"
          placeholder="请选择展现位置"
          clearable
          :style="{ width: '100%' }"
        >
          <el-option
            v-for="(item, index) in showPositionOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="能否显示" prop="isShow">
        <el-radio-group v-model="formData.showStatus" size="medium">
          <el-radio
            v-for="(item, index) in isShowOptions"
            :key="index"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item size="medium">
        <el-button class="mr8" type="primary" @click="submitForm"
          >提交</el-button
        >
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
  </base-container>
</template>
<script>
import { pick } from "ramda";
import { addOrUpdateBanner, getBannerInfo } from "@/api/content";
import { getDict } from "@/api/dict";
import SingleUploadCos from "@/components/upload/single-upload-cos";
import { ROUTER_BANNER_LIST } from "./const";
export default {
  name: "BannerAdd",
  components: {
    SingleUploadCos
  },
  props: [],
  data() {
    return {
      imgfileList: [],
      uploadAction: "",
      formData: {
        id: "",
        url: "",
        link: "",
        title: " ",
        comment: " ",
        orderby: 0,
        position: 1,
        showStatus: 1
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur"
          }
        ],
        position: [
          {
            required: true,
            message: "请选择展现位置",
            trigger: "change"
          }
        ]
      },
      showPositionOptions: [
        {
          label: "闪屏页",
          value: 1
        }
      ],
      isShowOptions: [
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ]
    };
  },

  methods: {
    getDict() {
      getDict({ typeCode: "advert_show_type" }).then(res => {
        this.showPositionOptions = res.data.map(item => {
          return {
            label: item.name,
            value: item.value
          };
        });
      });
    },
    submitForm() {
      this.$refs["bannerForm"].validate(valid => {
        if (!valid) return;
        addOrUpdateBanner(this.formData).then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "提交成功",
              onClose: () => {
                this.$router.push({ path: ROUTER_BANNER_LIST });
              }
            });
          }
        });
      });
    },
    resetForm() {
      this.$refs["bannerForm"].resetFields();
    },
    initForm() {
      const { id } = this.$route.query;
      if (id) {
        let bannerDetail =
          JSON.parse(window.localStorage.getItem("bannerDetail")) || "";
        if (bannerDetail) {
          this.formData = pick([
            "url",
            "title",
            "comment",
            "position",
            "showStatus",
            "orderby",
            "id"
          ])(bannerDetail);
        }
      }
    }
  },
  mounted() {
    this.initForm();
    this.getDict();
  }
};
</script>
<style>
.el-upload__tip {
  line-height: 1.2;
}
</style>

<style lang="scss" scoped>
.banner-container {
  background: #fff;
  display: flex;
  justify-content: center;
  .banner-form {
    padding-top: 50px;
    min-height: 881px;
  }
}
</style>
